<template>
  <div v-if="rawHtml" ref="htmlContainer" v-html="rawHtml"></div>
</template>

<script>
import { getShareDataHtml } from '@/services/company.js';
export default {
  data() {
    return {
      rawHtml: '',
    };
  },

  async mounted() {
    const id = this.$route.query.companyId || this.$route.query.id;

    try {
      const response = await getShareDataHtml(id);

      console.log(
        'Fetched HTML:',
        response.data.company_by_pk.growthFrameworkExport
      );

      const html = response.data.company_by_pk.growthFrameworkExport;

      this.rawHtml = html || '<h1>Error loading page</h1>';
    } catch (error) {
      console.error('Error fetching HTML:', error);
      this.rawHtml = '<h1>Error loading page</h1>';
    }
  },
};
</script>

<style></style>
